export default function ContactSection() {
  return (
    <footer className="w-full bg-background-100 py-16 md:py-24 px-6 md:px-12">
      <div className="w-full max-w-[1280px] mx-auto relative">
        <div className="hidden lg:block absolute -left-6 top-12 w-[80px] h-[120px] bg-foreground-950 rounded-md" style={{ transform: 'rotate(-12deg)' }}></div>
        <div className="hidden lg:block absolute -right-6 top-12 w-[80px] h-[120px] bg-foreground-950 rounded-md" style={{ transform: 'rotate(12deg)' }}></div>

        <div className="bg-background-50 rounded-[32px] px-8 md:px-16 py-14 md:py-20">
          <div className="flex flex-col lg:flex-row gap-14 lg:gap-0">
            <div className="lg:w-1/4">
              <p className="text-xs font-semibold uppercase tracking-[0.1em] text-foreground-400 font-label mb-6">
                Contact
              </p>
              <div className="space-y-1 text-sm text-foreground-600 font-body leading-[1.8]">
                <p>Ilica 322</p>
                <p>Zagreb, 10000</p>
                <p>Croatia</p>
                <div className="mt-4 pt-4 border-t border-background-200/70">
                  <p>+385 957965482</p>
                  <p>ceo@luradosdigital.com</p>
                </div>
              </div>
            </div>

            <div className="lg:w-3/4 grid grid-cols-1 sm:grid-cols-3 gap-10 lg:pl-16">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.1em] text-foreground-400 font-label mb-5">
                  Expertise
                </p>
                <div className="space-y-[0.55rem] text-sm text-foreground-700 font-body">
                  <p>iOS Platform</p>
                  <p>System Architecture</p>
                  <p>Performance Engineering</p>
                  <p>UI &amp; UX Design</p>
                </div>
              </div>

              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.1em] text-foreground-400 font-label mb-5">
                  Approach
                </p>
                <div className="space-y-[0.55rem] text-sm text-foreground-700 font-body">
                  <p>Clean Architecture</p>
                  <p>Agile Workflows</p>
                  <p>Code Quality</p>
                  <p>Continuous Delivery</p>
                </div>
              </div>

              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.1em] text-foreground-400 font-label mb-5">
                  Values
                </p>
                <div className="space-y-[0.55rem] text-sm text-foreground-700 font-body">
                  <p>Technical Excellence</p>
                  <p>Long-Term Thinking</p>
                  <p>User-Centered Design</p>
                  <p>Continuous Learning</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-16 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500 font-body">
              <span>&copy; {new Date().getFullYear()} LURADOS DIGITAL d.o.o.</span>
              <span className="text-foreground-300">|</span>
              <span>All rights reserved</span>
              <span className="text-foreground-300">|</span>
              <span>Zagreb, Croatia</span>
            </div>
            <div className="flex gap-3">
              <div className="w-10 h-10 bg-foreground-950 rounded-md flex items-center justify-center">
                <span className="text-[10px] font-bold uppercase text-background-50 font-label tracking-wider">HR</span>
              </div>
              <div className="w-10 h-10 bg-background-200 rounded-md flex items-center justify-center">
                <span className="text-[10px] font-bold uppercase text-foreground-700 font-label tracking-wider">EN</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}